/**
 * Created by Ivan on 24.12.2025
 */

const LightningRushGardenFinishRowView = cc.Scale9Sprite.extend({
    ctor: function (row, options) {
        options = options || {};

        this.id = row.id;
        this.row = row;
        this.options = options;

        options.prizes = options.prizes !== undefined ? options.prizes : true;
        options.badges = options.badges !== undefined ? options.badges : true;

        const styles = cleverapps.styles.LightningRushGardenFinishRowView;
        this.contentHeight = styles.content.height;

        this.clickableArea = options.clickableArea;

        const background = this.isPlayer() ? bundles.lightning_rush_row.frames.row_you_bg_png : bundles.lightning_rush_row.frames.row_player_bg_png;
     
        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        this.updatePlace(row.data.place);

        const place = this.createPlace(row.data.place);
        const avatar = this.avatar = this.createAvatar();
        const name = this.name = this.createName();
        name.setAnchorPoint(0.5, 0.5);
        name.setAlignment(styles.name.position);

        const prize = this.createPrize();

        const score = this.scoreNode = this.createScore();

        cleverapps.tooltipManager.create(score, {
            text: Messages.get(this.options.scoreTooltip || "ResultTooltip"),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            clickableArea: this.clickableArea
        });

        const nameWrapper = this.nameWrapper = new cc.Node();
        nameWrapper.setAnchorPoint(0.5, 0.5);
        nameWrapper.addChild(name);
        this.content = new cleverapps.Layout([place, avatar, nameWrapper, prize, score].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            padding: styles.content.padding
        });

        if (options.mission && this.isPlayer() && cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this, () => {
                options.mission.update(10);
            });
        }

        this.addChild(this.content);
        this.onResize();
        this.content.setAlignment(styles.content);
    },

    isPlayer: function () {
        return this.row.data.player;
    },

    onResize: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishRowView;

        cleverapps.UI.fitToBox(this.avatar, {
            height: this.contentHeight,
            maxScale: 1
        });

        if (this.prizeNode) {
            cleverapps.UI.fitToBox(this.prizeNode, {
                width: styles.prize.width,
                height: this.contentHeight
            });
        }

        let width = this.options.width || styles.width;
        if (this.options.dynamicWidth) {
            width = Math.max(styles.minWidth, Math.min(width, cleverapps.resolution.getSceneSize().width - styles.scenePadding[cleverapps.resolution.mode] * 2));
        }

        this.setContentSize2(width, this.options.height || styles.height);
        if (this.bg) {
            this.bg.setContentSize2(width, styles.height);
        }
        const margin = styles.content.margin;
        const padding = styles.content.padding;

        const paddingX = padding.left + padding.right;
        const nameWidth = width - paddingX - [this.placeNode, this.avatar, this.prizeNode, this.scoreNode].filter(Boolean).reduce((width, item) => width + item.width * item.scaleX + margin, 0);

        cleverapps.UI.fitToBox(this.name, {
            width: nameWidth,
            height: styles.name.height
        });

        this.nameWrapper.setContentSize2(nameWidth, styles.height);
        this.content.setOptions({ margin });
    },

    createPlace: function (place) {
        const styles = cleverapps.styles.LightningRushGardenFinishRowView;

        const placeNode = this.placeNode || new cc.Node();
        this.placeNode = placeNode;
        placeNode.setAnchorPoint(0.5, 0.5);

        placeNode.removeAllChildren();

        let content;
        const badgeIcon = bundles.lightning_rush_row.frames[`badge_${place}`];
        if (this.options.badges && badgeIcon) {
            content = new cc.Sprite(badgeIcon);
        } else {
            const font = this.isPlayer() ? cleverapps.styles.FONTS.LIGHTNING_RUSH_FINISH_NUMBER_PLAYER_TEXT : cleverapps.styles.FONTS.LIGHTNING_RUSH_FINISH_NUMBER_TEXT;
            content = cleverapps.UI.generateImageText(this.row.data.notInTop ? "-" : place, font);
        }

        placeNode.setContentSize2(
            Math.max(
                this.options.badges && styles.place.withBadge.width || 0,
                styles.place.background ? styles.place.background.width : styles.place.width
            ),
            this.contentHeight
        );

        placeNode.addChild(content);
        content.setAlignment(placeNode.width / 2, placeNode.height / 2);

        return placeNode;
    },

    createAvatar: function () {
        return new cleverapps.UI.Avatar(this.row.data.avatar, {
            userId: this.row.id,
            frame: this.isPlayer() ? bundles.lightning_rush_row.frames.table_avatar_frame2 : bundles.lightning_rush_row.frames.table_avatar_frame,
            padding: cleverapps.styles.LightningRushGardenFinishRowView.avatar.padding
        });
    },

    createName: function () {
        const userName = this.row.data.name
            || typeof this.row.id === "string" && `Player_${this.row.id.substring(this.row.id.length - 3)}` || "";

        const font = this.isPlayer() ? cleverapps.styles.FONTS.LIGHTNING_RUSH_FINISH_PLAYER_TEXT : cleverapps.styles.FONTS.LIGHTNING_RUSH_FINISH_TEXT;

        return cleverapps.UI.generateOnlyText(userName, font);
    },

    createPrize: function () {
        if (!this.options.prizes) {
            return;
        }

        const styles = cleverapps.styles.LightningRushGardenFinishRowView;

        const width = styles.prize.width;

        if (this.prizeNode) {
            cleverapps.tooltipManager.remove(this.prizeNode);
        }

        const prizeNode = this.prizeNode || new cc.Node();
        this.prizeNode = prizeNode;
        prizeNode.setAnchorPoint(0.5, 0.5);
        prizeNode.removeAllChildren();

        prizeNode.setContentSize2(width, this.contentHeight);

        const prizeIcon = this.prizeIcon = this.row.data.prizeIcon && bundles.lightning_rush_row.frames.prize_png;
        if (prizeIcon) {
            const prize = new cc.Sprite(prizeIcon);
            prizeNode.addChild(prize);
            prize.setAlignment({ x: { align: "center" }, y: { align: "center" } });

            cleverapps.tooltipManager.create(prizeNode, {
                rewards: this.row.data.prizeRewards,
                clickableArea: this.clickableArea
            });
        }

        return prizeNode;
    },

    createScore: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishRowView.score;

        const background = new cc.Scale9Sprite(bundles.lightning_rush_row.frames[this.isPlayer() ? "substrate_you_png" : "substrate_player_png"]);
        let icon;

        if (this.options.dataIcon) {
            icon = this.scoreIcon = new cc.Sprite(this.options.dataIcon);
            icon.setAlignment(styles.icon);
            background.addChild(icon);
        }

        const font = cleverapps.styles.FONTS.LIGHTNING_RUSH_FINISH_SCORE_TEXT;
        const amount = this.scoreAmount = cleverapps.UI.generateImageText("222", font);

        background.addChild(amount);

        background.onResize = function () {
            background.setContentSize2(styles.width, styles.height);
            amount.setAlignment((background.width + (icon ? icon.x + icon.width / 4 : 0)) / 2, background.height / 2);
            amount.fitToSize = {
                width: (background.width - (icon ? icon.x + icon.width / 4 : 0)) * 0.7,
                height: background.height * 0.9
            };
            this.updateScore(this.row.score, { silent: true });
        }.bind(this);
        background.onResize();

        return background;
    },

    updatePlace: function (place) {
        if (this.place === place) {
            return;
        }
        this.place = place;

        this.createPlace(this.place);
        this.updateLocalZOrder();
    },

    updateLocalZOrder: function () {
        this.setLocalZOrder(this.isPlayer() ? 1000 : this.place);
    },

    updateScore: function (score, options) {
        options = options || {};

        if (!this.scoreAmount || this.score === score) {
            return;
        }

        this.score = score;

        this.scoreAmount.stopAllActions();
        this.scoreAmount.setString(this.score);
        this.scoreAmount.fitTo(this.scoreAmount.fitToSize.width, this.scoreAmount.fitToSize.height);

        if (options.silent) {
            return;
        }

        this.scoreAmount.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.5),
            new cc.ScaleTo(0.2, 1)
        ));

        if (this.scoreIcon && this.options.dataIconAnimation && this.isPlayer()) {
            const animation = new cleverapps.Spine(this.options.dataIconAnimation);
            animation.setAnimation(0, "animation");
            animation.setLocalZOrder(100);
            this.addChild(animation);

            const updatePosition = function () {
                const parent = animation.parent;
                animation.setPosition(parent.convertToNodeSpace(this.scoreIcon.parent.convertToWorldSpace(this.scoreIcon.getPosition())));
                animation.setVisible(cc.rectContainsPoint(cc.rect(0, 0, parent.width, parent.height), animation.getPosition()));
            }.bind(this);

            animation.update = function (dt) {
                cleverapps.Spine.prototype.update.call(this, dt);
                updatePosition();
            }.bind(this);

            animation.scheduleUpdate();
            updatePosition();

            animation.replaceParentSamePlace(this.clickableArea, { keepScale: true });

            cleverapps.effects.fire(this.options.dataIconAnimationEffect);
        }
    },

    updatePrize: function () {
        if (!this.options.prizes || this.prizeIcon === this.row.data.prizeIcon) {
            return;
        }

        this.createPrize();
        this.prizeNode.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.1),
            new cc.ScaleTo(0.2, 1)
        ));
    },

    updateRow: function (row) {
        this.row = row;
        
        this.updatePlace(this.row.data.place);
        this.updatePrize();
        this.updateScore(this.row.score);
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    LIGHTNING_RUSH_FINISH_ROW_COLOR: new cc.Color(0, 127, 54, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTNING_RUSH_FINISH_NUMBER_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    LIGHTNING_RUSH_FINISH_NUMBER_PLAYER_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.LIGHTNING_RUSH_FINISH_ROW_COLOR
    },
    LIGHTNING_RUSH_FINISH_PLAYER_TEXT: {
        name: "lightstroke",
        size: 30,
        color: cleverapps.styles.COLORS.LIGHTNING_RUSH_FINISH_ROW_COLOR
    },
    LIGHTNING_RUSH_FINISH_TEXT: {
        name: "lightstroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    LIGHTNING_RUSH_FINISH_SCORE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.LightningRushGardenFinishRowView = {
    width: 1050,
    height: 138,

    minWidth: 700,
    scenePadding: [100, 250, 250],

    content: {
        height: 70,
        margin: 10,
        x: { align: "center" },
        y: { align: "center", dy: 3 },

        padding: {
            left: 20,
            right: 20
        }
    },

    place: {
        withBadge: {
            width: 60
        },

        background: {
            width: 50,
            height: 50,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        },

        width: 50
    },

    name: {
        height: 80,

        position: [
            {
                x: { align: "left", dx: 10 },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 10 },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 10 },
                y: { align: "center", dy: 0 }
            }
        ]
    },

    avatar: {
        padding: {
            x: 0,
            top: 0,
            bottom: 0
        }
    },

    prize: {
        width: 110
    },

    score: {
        width: 140,
        height: 55,

        icon: [{
            x: 12,
            y: { align: "center", dy: -1 }
        }, {
            x: 11,
            y: { align: "center" }
        }, {
            x: 11,
            y: { align: "center" }
        }]
    }
};